import * as React from 'react';
import { /*Button, */ PageHeader, Breadcrumbs } from 'modules';
import { Trans } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import { Routes } from 'routes/Routes';

const NotFoundScene = () => {
  return (
    <>
      <PageHeader>
        <Breadcrumbs>
          <Breadcrumbs.Item to="/" active={false}>
            <Trans>Page not found</Trans>
          </Breadcrumbs.Item>
        </Breadcrumbs>
      </PageHeader>

      <div className="ht-80v d-flex align-items-center justify-content-center">
        <div className="wd-lg-70p wd-xl-50p tx-center pd-x-40">
          <h1 className="tx-100 tx-xs-140 tx-normal tx-inverse tx-roboto mg-b-0">404!</h1>
          <h5 className="tx-xs-24 tx-normal mg-b-20 lh-5">
            <Trans>The page your are looking for has not been found</Trans>
          </h5>
          {/* <div className="d-flex justify-content-center">
            <Link to={Routes.dashboard}>
              <Button variant="primary">
                <Trans>Go to dashboard</Trans>
              </Button>
            </Link>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default NotFoundScene;
